import { Link, useParams } from "react-router-dom"
import DoctorsBySpeciality from './DoctorsBySpeciality';
import { useState, useEffect } from "react";
import SEO from './SEO';
import { useAppointment } from '../context/AppointmentContext';

const DoctorDetail = () => {
  const { slug } = useParams();
  const [doctor, setDoctor] = useState(null);
  const { open: openAppointment } = useAppointment();
  // const allDoctors = Object.values(DoctorsBySpeciality).flat();
  // //console.log(allDoctors);
  // const generateSlug = (name) =>
  // name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

  // const doctor = allDoctors.find(
  //   (doc) => generateSlug(doc.name) === slug.toLowerCase()
  // );
  // console.log(doctor);
  const generateSlug = (name) =>
    name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");


  useEffect(() => {
    const allDoctors = Object.values(DoctorsBySpeciality).flat();
    const foundDoctor = allDoctors.find(
      (doc) => generateSlug(doc.name) === slug.toLowerCase()
    );
    setDoctor(foundDoctor);
  }, [slug]);

  if (!doctor) {
    return (
      <div className="p-8 text-center text-red-600 font-semibold text-xl">
        Doctor not found.
      </div>
    );
  }
  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title={doctor ? `${doctor.name} – ${doctor.specialty} | MAMS Hospitals Hyderabad` : "Doctor Profile | MAMS Hospitals"}
        description={doctor ? `${doctor.name}, ${doctor.specialty} at MAMS Hospitals Bachupally Hyderabad. ${doctor.qualifications}. Book an appointment today.` : "Expert doctors at MAMS Hospitals Hyderabad."}
        keywords={doctor ? `${doctor.name}, ${doctor.specialty}, MAMS Hospitals, doctor Hyderabad, Bachupally` : "MAMS Hospitals doctors"}
        canonicalUrl={`https://mamshospitals.com/doctors/${slug}`}
      />
      {/* Hero Section */}
      <section className="bg-primary/5 py-12">
        <div className="container mx-auto px-4 max-w-6xl">
          <Link to="/doctors" className="inline-flex items-center text-teal-600 font-medium mb-6">
            <svg className="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Doctors
          </Link>

          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="md:w-1/3">
              <div className="rounded-lg overflow-hidden border border-gray-200 bg-white">
                <img
                  src={doctor.imageUrl || "/placeholder.svg"}
                  alt={doctor.name}
                  className="w-full aspect-square object-cover"
                />
              </div>
            </div>

            <div className="md:w-2/3">
              <h1 className="text-3xl md:text-4xl font-semibold text-gray-800 mb-2">{doctor.name}</h1>
              <p className="text-teal-600 font-medium text-lg mb-4">{doctor.specialty}</p>
              <p className="text-gray-600 mb-6">
                {doctor.qualifications} • {doctor.experience} Experience
              </p>

              <div className="flex flex-wrap gap-2 mb-6">
                {doctor.specializations.map((spec, index) => (
                  <span key={index} className="bg-teal-100 text-teal-600 px-3 py-1 rounded-full text-sm">
                    {spec}
                  </span>
                ))}
              </div>

              <ul className="text-gray-600 mb-6 space-y-2">
                {(Array.isArray(doctor.profile) ? doctor.profile : [doctor.profile]).map((point, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <span className="text-teal-600 font-bold" aria-hidden="true">•</span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>

              <div className="flex flex-col sm:flex-row gap-4">
                <button onClick={openAppointment} className="bg-teal-600 text-white px-6 py-3 rounded-full font-medium hover:bg-teal-700 transition-colors w-full sm:w-auto">
                    Book Appointment
                </button>
                <button className="bg-gray-100 text-gray-800 px-6 py-3 rounded-full font-medium hover:bg-gray-200 transition-colors w-full sm:w-auto">
                  Contact Doctor
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctor Details */}
      <section className="py-12 md:py-16 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="md:col-span-2">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">
                About {doctor.name}
              </h2>

              <div className="prose max-w-none mb-8">
                {doctor.detailedProfile.split("\n\n").map((paragraph, index) => (
                  <p key={index} className="text-gray-600 mb-4">
                    {paragraph.trim()}
                  </p>
                ))}
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mb-4">Education & Training</h3>
              <ul className="space-y-2 mb-8">
                {doctor.education.map((edu, index) => (
                  <li key={index} className="flex items-start gap-2 text-gray-600">
                    <span className="text-teal-600">•</span>
                    {edu}
                  </li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mb-4">Languages</h3>
              <div className="flex flex-wrap gap-2 mb-8">
                {doctor.languages.map((lang, index) => (
                  <span key={index} className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm">
                    {lang}
                  </span>
                ))}
              </div>
            </div>

            <div>
              <div className="border border-gray-200 rounded-lg p-6 bg-white">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Appointment Information</h3>

                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <svg className="h-5 w-5 text-teal-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <div>
                      <p className="font-medium text-gray-800">Available Days</p>
                      <p className="text-gray-600">{doctor.availableDays.join(", ")}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <svg className="h-5 w-5 text-teal-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <div>
                      <p className="font-medium text-gray-800">Consultation Hours</p>
                      <p className="text-gray-600">{doctor.availableTime}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <svg className="h-5 w-5 text-teal-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    <div>
                      <p className="font-medium text-gray-800">Location</p>
                      <p className="text-gray-600">MAMS Hospitals, Bachupally, Hyderabad</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <svg className="h-5 w-5 text-teal-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                      />
                    </svg>
                    <div>
                      <p className="font-medium text-gray-800">Contact</p>
                      <p className="text-gray-600">+91-7399999981</p>
                    </div>
                  </div>
                </div>

                <div className="mt-6">
                  <button onClick={openAppointment} className="w-full bg-teal-600 text-white px-6 py-3 rounded-full font-medium hover:bg-teal-700 transition-colors">
                    Book Appointment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default DoctorDetail
